// Returns the string in lowercase
export default function (value) {
  if (!value) return "";
  return value.toLowerCase();
}
